"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareIcon = void 0;
var Preact = __importStar(require("preact"));
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
/** Made by opening the svg exported from figma and manually copying the relevant bits into an
 * SvgIcon (and removing fill so it obeys colour setting).
 * Please see https://mui.com/material-ui/icons/#svgicon
 */
function ShareIcon(props) {
    return (Preact.h(SvgIcon_1.default, __assign({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
        Preact.h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 15C16.9 15 15.9 15.5 15.2 16.2L9.9 13.1C9.9 12.7 10 12.4 10 12C10 11.6 9.9 11.3 9.9 10.9L15.2 7.8C15.9 8.5 16.9 9 18 9C20.2 9 22 7.2 22 5C22 2.8 20.2 1 18 1C15.8 1 14 2.8 14 5C14 5.4 14.1 5.7 14.1 6.1L8.8 9.2C8.1 8.5 7.1 8 6 8C3.8 8 2 9.8 2 12C2 14.2 3.8 16 6 16C7.1 16 8.1 15.5 8.8 14.8L14.1 17.9C14.1 18.3 14 18.6 14 19C14 21.2 15.8 23 18 23C20.2 23 22 21.2 22 19C22 16.8 20.2 15 18 15ZM16.3 3.9C16.4 3.7 16.6 3.5 16.8 3.4C17.2 3.1 17.6 3 18 3C18.4 3 18.8 3.1 19.1 3.3C19.3 3.4 19.5 3.6 19.6 3.8C19.9 4.2 20 4.6 20 5C20 5.4 19.9 5.8 19.7 6.1C19.6 6.3 19.4 6.5 19.2 6.6C18.8 6.9 18.4 7 18 7C17.8 7 17.7 7 17.5 6.9H17.4C17.3 6.9 17.2 6.8 17.1 6.8C17.1 6.8 17 6.8 17 6.7C16.9 6.6 16.8 6.6 16.7 6.5C16.7 6.5 16.7 6.5 16.6 6.4C16.5 6.3 16.4 6.2 16.3 6.1C16.3 6.1 16.3 6.1 16.3 6C16.3 5.9 16.2 5.8 16.2 5.7V5.6C16 5.3 16 5.2 16 5C16 4.6 16.1 4.2 16.3 3.9ZM7.8 13C7.7 13 7.7 13 7.8 13C7.7 13 7.7 13 7.8 13C7.4 13.7 6.8 14 6 14C4.9 14 4 13.1 4 12C4 10.9 4.9 10 6 10C6.7 10 7.3 10.4 7.7 10.9C7.9 11.3 8 11.7 8 12C8 12.3 7.9 12.7 7.8 13ZM18 21C16.9 21 16 20.1 16 19C16 18.7 16.1 18.4 16.2 18.1C16.2 18.1 16.2 18 16.3 18C16.3 18 16.3 17.9 16.4 17.9C16.8 17.4 17.4 17 18.1 17C19.2 17 20.1 17.9 20.1 19C20.1 20.1 19.1 21 18 21Z" })));
}
exports.ShareIcon = ShareIcon;
